export const i18n = {
  title: 'Sign in',
  /** MCPeer.ai wording for the same page. */
  peer: { title: 'Sign in to peer', subtitle: "Agents peer with your apps as you. First, prove it's you.", host: 'portal.mcpeer.ai' },
  subtitle: (org: string) => `Portal for ${org}`,
  /** Public access: the workspace name is not the point, the product is. */
  subtitlePublic: 'Turn any app into an MCP server for your agents.',
  continueWith: (provider: string) => `Continue with ${provider}`,
  providerName: {
    google: 'Google Workspace',
    microsoft: 'Microsoft Entra ID',
    oidc: 'your identity provider',
    local: 'email',
  } as Record<string, string>,
  /** Public access: any Google account, not only Workspace ones. */
  providerNamePublic: { google: 'Google', microsoft: 'Microsoft' } as Record<string, string>,
  domainsHint: (domains: string[]) => `Only ${domains.join(', ')} accounts can sign in.`,
  /** The chip shown when an agent opened this page to be authorised: [agent, text, connector, text]. */
  waiting: (agent: string, connector: string) => [agent, ' is waiting to connect to ', connector, ". You'll pick its tools after signing in."],
  waitingPeer: (agent: string, connector: string) => [agent, ' is waiting to peer with ', connector, ". You'll pick its tools after signing in."],
  publicHint: (providers: string[]) => `Any ${providers.length ? providers.join(' or ') : 'verified'} account. New accounts are created on first sign-in.`,
  emailLabel: 'Work email',
  emailPlaceholder: 'you@company.com',
  localButton: 'Sign in',
  localHint: 'Local sign-in is a development convenience. Production uses SSO.',
  loadingProviders: 'Checking how your organisation signs in…',
  errorTitle: 'Could not sign in',
};
